import { useEffect, useState } from "react";

const isTargetDateExpired = (targetDate) => {
  const targetTime = new Date(targetDate).getTime();

  if (Number.isNaN(targetTime)) {
    return true;
  }

  return targetTime <= Date.now();
};

const useHasExpiredDate = (targetDate) => {
  const [hasExpiredDate, setHasExpiredDate] = useState(() =>
    isTargetDateExpired(targetDate)
  );

  useEffect(() => {
    const syncExpiredState = () => {
      const expired = isTargetDateExpired(targetDate);
      setHasExpiredDate(expired);
      return expired;
    };

    if (syncExpiredState()) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      if (syncExpiredState()) {
        window.clearInterval(intervalId);
      }
    }, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [targetDate]);

  return hasExpiredDate;
};

export default useHasExpiredDate;

